module.exports = __webpack_public_path__ + "f6c321b58b7b24c258e79a089684a02e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Avenir-Light.eot?v=8.0d5e4
// module id = 927
// module chunks = 24